import React, { useState } from "react";
import { 
  Box, 
  Typography, 
  Tabs, 
  Tab, 
  Grid, 
  Card, 
  CardContent,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Avatar,
} from "@mui/material";
import {
  Business as BusinessIcon,
  People as PeopleIcon,
  Settings as SettingsIcon,
  TrendingUp as TrendingUpIcon,
} from "@mui/icons-material";
import Header from "../components/Header";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function AdminPage() {
  const [tabValue, setTabValue] = useState(0);
  const [newService, setNewService] = useState({ name: "", duration: "", price: "" });

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const services = [
    { id: 1, name: "Стрижка мужская", duration: "30 мин", price: "1500 ₽", active: true },
    { id: 2, name: "Стрижка женская", duration: "60 мин", price: "2500 ₽", active: true },
    { id: 3, name: "Окрашивание", duration: "120 мин", price: "4000 ₽", active: true },
    { id: 4, name: "Укладка", duration: "45 мин", price: "1800 ₽", active: false },
  ];

  const masters = [
    { id: 1, name: "Анна Петрова", specialization: "Парикмахер", rating: 4.8, active: true },
    { id: 2, name: "Мария Иванова", specialization: "Колорист", rating: 4.9, active: true },
    { id: 3, name: "Елена Сидорова", specialization: "Мастер по маникюру", rating: 4.7, active: false },
  ];

  const settings = [
    { key: "Название салона", value: "BarberPro" },
    { key: "Рабочие часы", value: "09:00 - 21:00" },
    { key: "Телефон", value: "+7 (900) 123-45-67" },
    { key: "Адрес", value: "г. Москва, ул. Примерная, 123" },
  ];

  return (
    <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
      <Header title="Админ панель" />
      
      <Box sx={{ p: 4 }}>
        {/* Заголовок */}
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Typography variant="h3" gutterBottom sx={{ fontWeight: 300, color: "text.primary" }}>
            Управление салоном
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 400 }}>
            Настройки и администрирование
          </Typography>
        </Box>
      
        <Tabs 
          value={tabValue} 
          onChange={handleTabChange} 
          sx={{ 
            borderBottom: "1px solid #e0e0e0", 
            mb: 4,
            "& .MuiTab-root": { 
              textTransform: "none", 
              fontWeight: 500,
              minWidth: 120
            }
          }}
        >
          <Tab icon={<BusinessIcon />} label="Услуги" />
          <Tab icon={<PeopleIcon />} label="Сотрудники" />
          <Tab icon={<SettingsIcon />} label="Настройки" />
          <Tab icon={<TrendingUpIcon />} label="Статистика" />
        </Tabs>

        <TabPanel value={tabValue} index={0}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={8}>
              <Card sx={{ border: "1px solid #e0e0e0", borderRadius: 2 }}>
                <CardContent sx={{ p: 3 }}>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 500, color: "text.primary" }}>
                    Список услуг
                  </Typography>
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Услуга</TableCell>
                          <TableCell>Длительность</TableCell>
                          <TableCell>Цена</TableCell>
                          <TableCell>Статус</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {services.map((service) => (
                          <TableRow key={service.id}>
                            <TableCell>{service.name}</TableCell>
                            <TableCell>{service.duration}</TableCell>
                            <TableCell>{service.price}</TableCell>
                            <TableCell>
                              <Chip 
                                label={service.active ? "Активна" : "Неактивна"} 
                                color={service.active ? "success" : "default"}
                                size="small"
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Card>
            </Grid>
            
            <Grid item xs={12} md={4}>
              <Card sx={{ border: "1px solid #e0e0e0", borderRadius: 2 }}>
                <CardContent sx={{ p: 3 }}>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 500, color: "text.primary" }}>
                    Добавить услугу
                  </Typography>
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    <TextField
                      label="Название услуги"
                      variant="outlined"
                      size="small"
                      value={newService.name}
                      onChange={(e) => setNewService({...newService, name: e.target.value})}
                    />
                    <TextField
                      label="Длительность"
                      variant="outlined"
                      size="small"
                      value={newService.duration}
                      onChange={(e) => setNewService({...newService, duration: e.target.value})}
                    />
                    <TextField
                      label="Цена"
                      variant="outlined"
                      size="small"
                      value={newService.price}
                      onChange={(e) => setNewService({...newService, price: e.target.value})}
                    />
                    <Button variant="contained" fullWidth>
                      Добавить услугу
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <Grid container spacing={3}>
            {masters.map((master) => (
              <Grid item xs={12} sm={6} md={4} key={master.id}>
                <Card sx={{ border: "1px solid #e0e0e0", borderRadius: 2 }}>
                  <CardContent sx={{ p: 3, textAlign: "center" }}>
                    <Avatar sx={{ bgcolor: "#2196F3", width: 64, height: 64, mx: "auto", mb: 2 }}>
                      <PeopleIcon />
                    </Avatar>
                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 500 }}>
                      {master.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                      {master.specialization}
                    </Typography>
                    <Typography variant="body2" gutterBottom>
                      Рейтинг: ⭐ {master.rating}
                    </Typography>
                    <Chip 
                      label={master.active ? "Активен" : "Неактивен"} 
                      color={master.active ? "success" : "default"}
                      size="small"
                    />
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </TabPanel>

        <TabPanel value={tabValue} index={2}>
          <Card sx={{ border: "1px solid #e0e0e0", borderRadius: 2, maxWidth: 600 }}>
            <CardContent sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 500, color: "text.primary" }}>
                Основные настройки
              </Typography>
              {settings.map((setting, index) => (
                <Box key={index} sx={{ mb: 3 }}>
                  <TextField
                    fullWidth
                    label={setting.key}
                    defaultValue={setting.value}
                    variant="outlined"
                    size="small"
                  />
                </Box>
              ))}
              <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
                <Button variant="contained">Сохранить</Button>
                <Button variant="outlined">Отмена</Button>
              </Box>
            </CardContent>
          </Card>
        </TabPanel>

        <TabPanel value={tabValue} index={3}>
          <Card sx={{ border: "1px solid #e0e0e0", borderRadius: 2 }}>
            <CardContent sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 500, color: "text.primary" }}>
                Статистика салона
              </Typography>
              <Box sx={{ 
                height: 400, 
                display: "flex", 
                alignItems: "center", 
                justifyContent: "center",
                border: "2px dashed #e0e0e0",
                borderRadius: 2,
                bgcolor: "background.default"
              }}>
                <Typography variant="body2" color="text.secondary" textAlign="center">
                  Детальная статистика и аналитика<br/>
                  <small>Здесь будут графики и отчеты</small>
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </TabPanel>
      </Box>
    </Box>
  );
}
